export function ratioBlock() {
    var aspect_ratio = 1;
    var $box = $(".box");

    $(window).resize(function(){
        $box.height( $box.width() * aspect_ratio );
    });

    $(window).on("load", function(){
        $box.height( $box.width() * aspect_ratio );
    });
}

